import React from 'react';
import AssignModalShell from '@core/components/assign/AssignModalShell';
import AssignReportTemplatesModalBody from './AssignReportTemplatesModalBody';
import ClearAllReportTemplatesConfirmModal from './ClearAllReportTemplatesConfirmModal';
import { useAssignReportTemplates } from '../hooks/useAssignReportTemplates';

type Props = {
  show: boolean;
  onHide: () => void;
  districtId: number;
  nationId?: number;
  onSaved?: () => void;
};

const AssignDistrictReportTemplatesModal: React.FC<Props> = ({
  show,
  onHide,
  districtId,
  nationId,
  onSaved,
}) => {
  const assign = useAssignReportTemplates({
    show,
    scope: 'DISTRICT',
    entityId: districtId,
    nationId,
    onHide,
    onSaved,
  });

  return (
    <>
      <AssignModalShell
        show={show}
        onHide={assign.handleClose}
        title="Manage District Templates"
        saving={assign.saving}
        onSave={assign.handleSave}
        saveDisabled={assign.saveDisabled}
      >
        <AssignReportTemplatesModalBody {...assign} />
      </AssignModalShell>

      <ClearAllReportTemplatesConfirmModal
        show={assign.showClearAllConfirm}
        departmentName={assign.selectedDepartmentName}
        scopeLabel={assign.scopeLabel}
        saving={assign.saving}
        onConfirm={assign.confirmClearAllSave}
        onCancel={assign.dismissClearAllConfirm}
      />
    </>
  );
};

export default AssignDistrictReportTemplatesModal;
